import styled from '@emotion/styled';

export const HiddenInput = styled.input`
  height: 0;
  left: -9999px;
  opacity: 0;
  padding: 0;
  pointer-events: none;
  position: absolute;
  width: 0;
`;
